export const AUDITBOT_ANIMATION_DURATION = 2000
